import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const RevenueList = React.lazy(() => import('@/modules/revenue/list/revenue-list'))
const RevenueEditPage = React.lazy(() => import('@/modules/revenue/edit/revenue-edit-page'))

const revenueRoutes = (
  <>
    <Route path='revenue/*' element={<RedirectToPlural />} />
    <Route path='revenues' Component={RevenueList} handle={{ title: 'Einnahmen', options: { noBackgroundColor: true } }} />
    <Route path='revenues/new/:type?/:relatedTypeId?' Component={RevenueEditPage} />
    <Route path='revenues/edit/:id/:type?' Component={RevenueEditPage} />
  </>
)

export default revenueRoutes
